import { useEffect } from "react";

import { useTopLevelUser } from "@bokio/contexts/TopLevelUserContext/useTopLevelUser";

import Layout from "../Layout/Layout";
import TopBar, { TopBarMode } from "../TopBar/TopBar";

import type { ReactNode } from "react";

export const UserRoute = ({ children }: { children: ReactNode }) => {
	const { clearUser } = useTopLevelUser();

	useEffect(() => {
		clearUser();
	}, [clearUser]);

	return (
		<Layout
			isDemo={false}
			noSideBar={true}
			menu={menuProps => (
				<div>
					<TopBar mode={TopBarMode.User} toggleMenu={menuProps.toggleMenu} />
				</div>
			)}
			content={<>{children}</>}
		/>
	);
};

export default UserRoute;
